import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { useRouter } from 'expo-router';

import { reviewDesk } from '@/design-system';
import { useTranslation } from '@/hooks/useTranslation';
import { reportRoute } from '@/navigation/routes';

/**
 * Compact link from a chat analysis message to the canonical report (D0).
 */
export function ReportCard({ sessionId }: { sessionId: number }) {
  const router = useRouter();
  const { t } = useTranslation();
  return (
    <View testID="report_card" style={styles.card}>
      <MaterialIcons name="assessment" size={22} color={reviewDesk.accent} />
      <View style={styles.copy}>
        <Text style={styles.title}>{t('report.card.title')}</Text>
        <Text style={styles.body}>{t('report.card.body')}</Text>
      </View>
      <Pressable
        testID="report_card_open"
        accessibilityRole="link"
        onPress={() => router.push(reportRoute(sessionId) as never)}
        style={({ pressed }) => [styles.button, pressed && styles.pressed]}
      >
        <Text style={styles.buttonText}>{t('report.card.open')}</Text>
        <MaterialIcons name="arrow-forward" size={16} color="#FFFFFF" />
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 12,
    padding: 14,
    marginBottom: 12,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: reviewDesk.accentSoft,
    backgroundColor: reviewDesk.accentWash,
  },
  copy: { flex: 1, minWidth: 180, gap: 2 },
  title: { color: reviewDesk.ink, fontSize: 15, fontWeight: '800' },
  body: { color: reviewDesk.inkSoft, fontSize: 14, lineHeight: 20 },
  button: {
    minHeight: 40,
    paddingHorizontal: 14,
    borderRadius: 10,
    backgroundColor: reviewDesk.accent,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
  },
  buttonText: { color: '#FFFFFF', fontSize: 14, fontWeight: '800' },
  pressed: { opacity: 0.8 },
});
